import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import CreditCard from 'components/payment-methods/credit-card';
import BusinessAccount from 'components/payment-methods/business-account';
import BusinessProfile from 'components/payment-methods/business-profile';

import PaymentMethodModel, { CREDIT_CARD_TYPE, BUSINESS_PROFILE_TYPE, BUSINESS_ACCOUNT_TYPE } from 'models/payment-method';
import NewPaymentMethodModel from 'models/braintree/new-payment-method';
import UserModel from 'models/user';
import Brand from 'models/brand';

const propTypes = {
  paymentMethod: PropTypes.oneOfType([
    PropTypes.instanceOf(PaymentMethodModel),
    PropTypes.instanceOf(NewPaymentMethodModel),
  ]).isRequired,
  user: PropTypes.instanceOf(UserModel).isRequired,
  brand: PropTypes.instanceOf(Brand).isRequired,
  defaultPaymentMethodId: PropTypes.string,
  setDefaultPaymentMethod: PropTypes.func.isRequired,
  deletePaymentMethod: PropTypes.func.isRequired,
  editPaymentMethod: PropTypes.func.isRequired,
  connectPaymentMethod: PropTypes.func.isRequired,
};

const defaultProps = {
  defaultPaymentMethodId: null,
};

class PaymentMethod extends Component {
  constructor(props) {
    super(props);

    this.setAsDefault = this.setAsDefault.bind(this);
    this.deleteMethod = this.deleteMethod.bind(this);
    this.editMethod = this.editMethod.bind(this);
    this.connectMethod = this.connectMethod.bind(this);
  }

  setAsDefault() {
    const { paymentMethod, setDefaultPaymentMethod } = this.props;
    setDefaultPaymentMethod(paymentMethod.id);
  }

  deleteMethod() {
    const { paymentMethod, deletePaymentMethod } = this.props;
    let methodType;
    switch (paymentMethod.type) {
      case BUSINESS_PROFILE_TYPE:
        methodType = 'business profile';
        break;
      default:
        methodType = 'credit card';
        break;
    }

    if (window.confirm(`Are you sure you want to delete this ${methodType}?`)) {
      deletePaymentMethod(paymentMethod.id);
    }
  }

  editMethod() {
    const { paymentMethod, editPaymentMethod } = this.props;
    editPaymentMethod(paymentMethod);
  }

  connectMethod() {
    const { paymentMethod, connectPaymentMethod } = this.props;
    connectPaymentMethod(paymentMethod);
  }

  render() {
    const { paymentMethod, user, defaultPaymentMethodId, brand } = this.props;
    const isDefault = paymentMethod.id === defaultPaymentMethodId;
    if (
      !brand.showBusinessPaymentMethods &&
      [BUSINESS_ACCOUNT_TYPE, BUSINESS_PROFILE_TYPE].includes(paymentMethod.type)
    ) {
      return null;
    }
    let paymentMethodBody;
    switch (paymentMethod.type) {
      case CREDIT_CARD_TYPE:
        paymentMethodBody = (<CreditCard
          user={user}
          paymentMethod={paymentMethod}
          deleteMethod={this.deleteMethod}
          editMethod={this.editMethod}
        />);
        break;
      case BUSINESS_ACCOUNT_TYPE:
        paymentMethodBody = (<BusinessAccount
          paymentMethod={paymentMethod}
        />);
        break;
      case BUSINESS_PROFILE_TYPE:
        paymentMethodBody = (<BusinessProfile
          paymentMethod={paymentMethod}
          user={user}
          deleteMethod={this.deleteMethod}
          editMethod={this.editMethod}
          connectMethod={this.connectMethod}
        />);
        break;
      default:
        paymentMethodBody = (<CreditCard
          user={user}
          paymentMethod={paymentMethod}
          deleteMethod={this.deleteMethod}
          editMethod={this.editMethod}
        />);
        break;
    }

    const defaultToggleClasses = cx({
      checkbox: true,
      selected: isDefault,
    });

    return (
      <div className="col-xs-12 col-md-4">
        <div className="heavy-shadowed">
          <div className="card-header">
            <div className={defaultToggleClasses} onClick={this.setAsDefault}>
              <label>{isDefault ? 'Default' : 'Set as default'}</label>
            </div>
          </div>
          {paymentMethodBody}
        </div>
      </div>
    );
  }
}

PaymentMethod.propTypes = propTypes;
PaymentMethod.defaultProps = defaultProps;

export default PaymentMethod;
